import { DatePipe } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from '../../_model/constants';
import { FilterDto } from '../../_model/filterDto';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { ReportFilterDto } from '../../_model/ReportFilterDto';
import { TableResponse } from '../../_model/table-response/table-response';
import { UserService } from "../user.service";
import { PageParams } from "./page-params";

@Injectable({
    providedIn: 'root'
})
export abstract class ReportTableService {

    baseUrl!: string;
    multilpleFilterBaseUrl!: string;
    isReportRoute = false;
    filterDto!: ReportFilterDto;

    constructor(private http: HttpClient, private userService: UserService,
        private router: Router, public datepipe: DatePipe) {
    }

    getTableData(filters: FormGroup, page: number, size: number): Observable<TableResponse> {
        const pageParams = PageParams.getPageParams(page, size);
        const url = this.userService.getClientBaseNewUrl() + this.multilpleFilterBaseUrl;

        // Check if there are active filters. The multipleFilterarray will have length > 0 if filters are applied.
        if (filters?.value?.multipleFilterarray?.length > 0) {
            this.createBody(filters);
            const body = this.filterDto;
            return this.http.post<TableResponse>(url, body, { params: pageParams });
        } else {
            // Default case when no filters are applied.
            // This happens on initial load or when filters are cleared.
            const currentDate = new Date();
            const todaysDate = this.datepipe.transform(currentDate, Constants.backendDateFormat);
            currentDate.setDate(currentDate.getDate() - 30);
            currentDate.setMinutes(0);
            currentDate.setHours(0);
            const startDate = this.datepipe.transform(currentDate, Constants.backendDateFormat);
            const body = {
                "dateName": "dateReceived",
                "date": startDate + " = " + todaysDate,
                "type": null
            };
            return this.http.post<TableResponse>(url, body, { params: pageParams });
        }
    }

    private createBody(filters: FormGroup) {
        let dto = new ReportFilterDto();
        let typeArr:Array<string> = [];
        filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty)  => {

            if (element.column == Constants.dateConst) {
                if (element.dateBackendName == Constants.dateReceived) {
                    dto.dateName = Constants.backendDateReceived;
                } else {
                    dto.dateName = Constants.backendScheduledStartDate;
                }

                let start_date = this.datepipe.transform(element.origionalStartDateFormat, Constants.backendDateFormat);
                let end_date = this.datepipe.transform(element.origionalEndDateFormat, Constants.backendDateFormat);
                dto.date = start_date + " = " + end_date;
            } else {
                typeArr.push(element.value)

            }

        });
        typeArr.forEach(function (value){
            dto.type.push(value);
        });
        this.filterDto = dto;
    }
}
